export default __webpack_public_path__ + "static/media/AetherPhoto1.1ce5e014.jpg";